<template>
  <div>
    <img :src="url + nowImg" alt="" />
  </div>
</template>

<script>
import { setHost } from '@/utils/common'

export default {
  name: 'ImageFrame',
  data() {
    return {
      nowImg: '',
      index: 0,
      host: '',
    }
  },
  filters: {},
  props: ['imglist'],
  computed: {
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      return url
    },
  },
  methods: {
    playImg() {
      let that = this
      let index = this.index
      let imglist = this.imglist
      this.nowImg = imglist[index].url
      setTimeout(() => {
        if (index == imglist.length - 1) {
          that.index = 0
        } else {
          that.index = index + 1
        }
        that.playImg()
      }, 1000)
    },
  },
  mounted() {
    this.host = setHost()
    if (this.imglist) {
      this.playImg()
    }
  },
}
</script>

<style lang="scss" scoped>
img {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
